import {List} from 'immutable';

export const baseSupplementValidators = {
  getAlttext() {
    // follows the convention set by Mandark
    if (
      this.isAttributeRequired('alttext') &&
      this.getValueForContentAttribute('alttext', '').length === 0
    ) {
      return new List(['You must provide alt text.']);
    }
    return null;
  },

  getAudio() {
    if (
      this.isAttributeRequired('audio') &&
      this.getValueForContentAttribute('audio', '').length === 0
    ) {
      return new List(['You must provide audio.']);
    }
    return null;
  },

  getCaption() {
    if (
      this.isAttributeRequired('caption') &&
      this.getValueForContentAttribute('caption', '').length === 0
    ) {
      return new List(['You must provide a caption.']);
    }
    return null;
  },

  getImageUrl() {
    if (
      this.isAttributeRequired('image') &&
      this.getValueForContentAttribute('image', '').length === 0
    ) {
      return new List(['You must provide an image.']);
    }
    return null;
  },

  getGenerationMode() {
    // The default only covers a missing key; an uploaded image stores an explicit null.
    const imagePrompt = this.getValueForContentAttribute('imagePrompt', '') ?? '';
    const generationMode = this.getValueForContentAttribute('generationMode', null);
    // Only error if user has typed a prompt but hasn't picked a mode
    if (imagePrompt.trim().length > 0 && !generationMode) {
      return new List(['Select a generation mode']);
    }
    return null;
  },

  getImagePrompt() {
    return null;
  },

  getAudioText() {
    return null;
  },

  getVoiceId() {
    return null;
  },

  getLanguageCode() {
    return null;
  },

  getName() {
    if (this.getName().length === 0) {
      return new List(['Enter a name']);
    }
    return null;
  },

  getText() {
    if (
      this.isAttributeRequired('text') &&
      this.getValueForContentAttribute('text', '').length === 0
    ) {
      return new List(['Enter text']);
    }
    return null;
  },

  getType() {
    if (!this.getType()) {
      return new List(['You must provide Type']);
    }
    return null;
  }
};
